import { useSiteSettings } from "@/hooks/use-site-settings";

// Announcement / utility bar above the nav (frame 4:2).
// DRB-21: reads the LIVE Firestore settings so the admin "Announcement bar" field works.
export function TopBar() {
  const { settings } = useSiteSettings();
  return (
    <div className="bg-night-blue text-white">
      <div className="mx-auto flex max-w-site items-center justify-center gap-3 px-4 py-1.5 text-center text-xs sm:justify-between">
        <p className="font-medium">{settings.announcementBar}</p>
        <a
          href="mailto:orders@drburnsreleaf.com"
          className="hidden items-center gap-1 hover:text-leaf-green sm:inline-flex"
        >
          orders@drburnsreleaf.com
        </a>
      </div>
    </div>
  );
}
